import { useMemo } from 'react'

import { symbolsFromFeed } from '@/app/lib/quant/liveSymbols'
import type { QuantFeedState } from '@/app/lib/quant/feedView'
import type { LiveSymbols } from '@/app/lib/quant/types'

export type QuantSymbolsState =
  | { status: 'loading' }
  | ({ status: 'ready' } & LiveSymbols)
  | { status: 'error'; message: string }

/**
 * The symbol list behind the pair dropdown, derived from the shell's feed poll (`QuantShellContext.feed`, built
 * from the feed's `live_instruments`). It makes no request of its own: `QuantShell` is the only feed reader (spec
 * 040), and its poll recovers by itself after a failure. `known` is false when the feed did not list its instruments.
 */
export function useQuantSymbols(feed: QuantFeedState | undefined): QuantSymbolsState {
  return useMemo<QuantSymbolsState>(() => {
    if (feed === undefined || feed.status === 'loading') return { status: 'loading' }
    if (feed.status === 'unavailable') {
      return { status: 'error', message: 'Market feed status unavailable. Retrying automatically.' }
    }
    return { status: 'ready', ...symbolsFromFeed(feed.feed) }
  }, [feed])
}
